import { render } from "./404.vue?vue&type=template&id=41890d00&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=41890d00&lang=scss&scoped=true"

import exportComponent from "/builds/rgLPqy5NH/0/rockwool/super-wykonawca-2022/performer-rating-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41890d00"]])

export default __exports__